import { DependencyList, useCallback } from 'react';
import { useDeepCompareMemoize } from './utils';

export function useDeepCompareCallback<T extends Function>(callback: T, dependencies: DependencyList) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(callback, dependencies.map(useDeepCompareMemoize));
}
